var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-content',{attrs:{"md-theme":"selection"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }